
import { Component, Vue } from 'vue-property-decorator'
import PipeDiameterTab from './components/PipeDiameterTab.vue'
import PipeMaterialTab from './components/PipeMaterialTab.vue'
import RoadSurfaceTab from './components/RoadSurfaceTab.vue'
import LeakPositionTab from './components/LeakPositionTab.vue'
import LeakReasonTab from './components/LeakReasonTab.vue'

@Component({
  name: 'BaseDataManagement',
  components: {
    PipeDiameterTab,
    PipeMaterialTab,
    RoadSurfaceTab,
    LeakPositionTab,
    LeakReasonTab
  }
})
export default class extends Vue {
  private activeTab = 'pipeDiameter'
}
